import React, { useState } from 'react';
import { Form, Input, Button, message, Spin } from 'antd';
import { loginUser } from '../../app/api';

const Login = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await loginUser({
        username: values.username || null,
        email: values.username || null,
        password: values.password,
      });
      if (response.data.success) {
        localStorage.setItem('token', response.data.accessToken);
        window.location.href = '/'
        message.success('Login successful!');
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || 'Login failed. Please try again!'
      );
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    message.error('Please fill in the required fields!');
  };

  return (
    <div style={{ maxWidth: '400px', margin: '100px auto' }}>
      <h2>Login</h2>
      <Form
        name="loginForm"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="username"
          rules={[{ required: true, message: 'Please input your username or email!' }]}
        >
          <Input placeholder="Username or Email" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            {loading ? <Spin size="small" /> : 'Login'}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
